import 'babel-polyfill';
import Vue from "vue";
import i18n from './plugins/i18n'
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import axios from "./utils/axios";
import {BootstrapVue, BootstrapVueIcons} from "bootstrap-vue";
import VueToastr from "vue-toastr";
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import VueMeta from 'vue-meta';

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "../src/assets/scss/index.scss";

// 크롬 체크
var userAgent = window.navigator.userAgent;
var isChrome = userAgent.indexOf('Chrome');
var isChromeMobile = userAgent.indexOf('CriOS');
var isSamsungBrowser = userAgent.indexOf('SamsungBrowser');
var isWindows = userAgent.indexOf('Windows NT');
var isEdge = userAgent.indexOf('Edge');
var isIE = userAgent.indexOf('Trident');

Vue.config.productionTip = false;

Vue.component(VueQrcode.name, VueQrcode);
Vue.prototype.$axios = axios;
Vue.use(VueToastr, {});
Vue.use(BootstrapVue, axios);
Vue.use(BootstrapVueIcons);
Vue.use(PerfectScrollbar);
Vue.use(VueMeta);

//Google OAuth
import GoogleAuth from '@/3rd_party/google_oAuth.js'
const gauthOption = {
    clientId: `${process.env.VUE_APP_GOOGLE_CLIENT_KEY}`,
    scope: 'profile email',
    prompt: 'select_account'
}
Vue.use(GoogleAuth, gauthOption)

new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount("#app");
